import React from 'react'
import Button from '@material-ui/core/Button'

const SubscriptionActions = ({ classes, sm, onSearch, onNew, showNew }) => (
  <div className={classes[sm ? 'buttons-sm' : 'buttons']}>
    <Button
      className={classes[sm ? 'button-sm' : 'button']}
      variant="contained"
      color="primary"
      onClick={onSearch}
    >
      Consultar Inscrição
    </Button>

    {showNew && (
      <Button
        className={classes[sm ? 'button-sm' : 'button']}
        variant="contained"
        color="primary"
        onClick={onNew}
      >
        Nova Inscrição
      </Button>
    )}
  </div>
)

export default SubscriptionActions
